import { Table } from "antd";
import React from "react";
import BannerCard from "../../common/components/BannerCard";
import useDashboard from "./useDashboard";

const DashboardTaxes = () => {
  const { data, taxColumns, loading, newLayoutTaxColumns, newLayout } = useDashboard();

  return (
    <BannerCard title="Tax Information">
      {newLayout ? (<div><Table loading={loading} size="small" dataSource={data?.taxes?.filter((o) => o.taxLocality.toUpperCase() === "FEDERAL")} columns={newLayoutTaxColumns} scroll={{ x: 480 }} pagination={false}/>
      <br/>
      <Table loading={loading} size="small" dataSource={data?.taxes?.filter((o) => o.taxLocality.toUpperCase() != "FEDERAL")} columns={taxColumns} scroll={{ x: 480 }} /></div>):
      (<Table loading={loading} size="small" dataSource={data?.taxes} columns={taxColumns} scroll={{ x: 480 }} />)
    }
    </BannerCard>
  );
};

export default DashboardTaxes;
